import AffectationStatusBadge from '@/components/Affectations/AffectationStatusBadge';
import { useGetAffectationsQuery } from '@/features/api/endpoints/affectationEndpoints';
import type { Affectation } from '@/models/types';
import { DATE_TIME_FORMAT } from '@/shared/utils/date-utils';
import { useTranslate } from '@tolgee/react';
import dayjs from 'dayjs';
import isObject from 'lodash/isObject';
import { DataTable } from 'mantine-datatable';

type Props = {
  userId: string;
};

const PendingAffectationsList = ({ userId }: Props) => {
  const { t } = useTranslate();

  const { data: affectations = [], isFetching } = useGetAffectationsQuery({
    fields: [
      '*',
      {
        role: ['name'],
        etablissement: ['name'],
      },
    ],
    filter: {
      user: { _eq: userId },
      status: {
        _eq: 'draft',
      },
    },
    sort: ['-date_created'],
  });

  return (
    <DataTable
      withTableBorder
      withColumnBorders
      fetching={isFetching}
      records={affectations}
      idAccessor="id"
      noRecordsText={t('onboarding.pending.empty')}
      columns={[
        {
          accessor: 'date_created',
          title: t('onboarding.pending.columns.date_created'),
          textAlign: 'center',
          render: ({ date_created }: Affectation) =>
            date_created ? dayjs(date_created).format(DATE_TIME_FORMAT) : '—',
        },
        {
          accessor: 'role',
          title: t('onboarding.form.role'),
          render: ({ role }: Affectation) => (isObject(role) ? role.name : '—'),
        },
        {
          accessor: 'etablissement',
          title: t('onboarding.form.etablissement'),
          render: ({ etablissement }: Affectation) =>
            isObject(etablissement) ? etablissement.name : '—',
        },
        {
          accessor: 'status',
          title: t('profil.affectations.columns.status'),
          render: ({ status }: Affectation) => <AffectationStatusBadge status={status} />,
        },
      ]}
    />
  );
};

export default PendingAffectationsList;
